import React from 'react';
import { Space } from 'antd';
import { FaFileAlt, FaCheckCircle } from 'react-icons/fa';
import { TextAreaInput, CheckboxInput } from '@/components/form';

interface NotesAccountStepProps {
  isEditing?: boolean;
}

export const NotesAccountStep: React.FC<NotesAccountStepProps> = ({ isEditing = false }) => {
  return (
    <div>
      <h3 className="text-lg font-semibold text-gray-900 mb-4 flex items-center gap-2">
        <FaFileAlt className="text-gray-600" />
        Notes
      </h3>

      <TextAreaInput
        name="notes"
        label="Internal Notes"
        placeholder="Add any internal notes about this user..."
        minRows={4}
      />

      {/* Account Setup Options (for new users only) */}
      {/* {!isEditing && (
        <>
          <h3 className="text-lg font-semibold text-gray-900 mt-8 mb-4 flex items-center gap-2">
            <FaCheckCircle className="text-gray-600" />
            Account Setup Options
          </h3>

          <Space direction="vertical" className='gap-1' size="middle">
            <CheckboxInput
              name="sendWelcomeEmail"
              className='mb-0'
              label="Send welcome email to user"
            />
            <CheckboxInput
              name="generatePassword"
              label="Generate temporary password"
            />
          </Space>
        </>
      )} */}
    </div>
  );
};

export default NotesAccountStep;
